import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../provider/CommonContext";
import { Col, Container, Row } from 'react-bootstrap';
import './ValueVolumeToppers.css';
import Pagination from '../../CommonUI/Pagination/Pagination';
import { useLocalStorage } from "../../utils/useLocalStorage";
import MarketEquity from "../MarketEquity";
import { Vortex } from 'react-loader-spinner';
import CallTrackApi from "../../Activity_Track/CallTrackApi";
 

function ValueVolumeToppers(props) {
    const [cocode, setcocode] = useLocalStorage("cocode", "");
    let optionInfoMarket = "Value / Volume Toppers";
    const [data, setData] = useState([]);
    const [valuebtn, setValueBtn] = useState("val");
    let optionTypeComp = "Daily Market Tracker";
    // const [valueLi, setValueLi] = useState("val");
    const [dataGroup, setDataGroup] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [groupValue, setGroupValue] = useState("BSE");
    // const [valueLy, setValueLy] = useState("M");
    const [groupIndex, setGroupIndex] = useState("BSE_SENSEX");
    const [groupIndexNSE, setGroupIndexNSE] = useState("NIFTY");

    const [loadingshow, setloadingshow] = useState(false);
    const { BaseURL } = useContext(URLstateContext);
    let getData, getDataGroup, eleBtn, eleBtnLoose, eleLi;
    let PageSize = 8;


    useEffect(() => {
        setloadingshow(true);
        if (groupValue === "BSE") {
            const getUrl = BaseURL + "ValueVolumeToppers";

            fetch(`${getUrl}/${groupValue}/${groupIndex}/Day/-/-/${valuebtn}`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    // console.log(getData, "getData")
                    setloadingshow(false);
                })
                .catch((error) => {
                });
        } else {
            const getUrl = BaseURL + "ValueVolumeToppers";
            fetch(`${getUrl}/${groupValue}/${groupIndexNSE}/Day/-/-/${valuebtn}`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    //console.log(getData, "getData")
                    setloadingshow(false);
                })
                .catch((error) => {
                });
        }

        const getUrlGroup = BaseURL + "GroupMaster";
        fetch(`${getUrlGroup}/${groupValue}`)
            .then((response) => response.json())
            .then((dataG) => {
                getDataGroup = dataG.data;
                setDataGroup(getDataGroup);
                //console.log(getDataGroup, "getDataGroup")
            })
            .catch((error) => {
            });

    }, [groupValue, valuebtn, groupIndex, groupIndexNSE]);



    const currentTableData = useMemo(() => {
        if (data != null && data != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (data != null && data != []) {
                if (data.length > 0) {
                    return data.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, data]);
    const routeChange = (event) => {
        const compcocode = event.currentTarget.dataset.id;
        const compcode_array = compcocode.split('-');
        const getCoCodeId = compcode_array[0].replace(/ /g, '-').replace('&', 'and').replace('+', '');
        setcocode(compcode_array[1]);
        window.open("/stocks/" + getCoCodeId.toLowerCase(), '_blank');
    };
    CallTrackApi("Value Volume Toppers",window.location.href);
    return (
        <>
            <div class="col-12 p-0 breadcrum ">
                <ul>
                    <li><a href="/">Home</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/market/stocks">Stocks</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li>Value / Volume Toppers</li>
                </ul>
            </div>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='value-loser-sc'>
                            <div className='value-header'>
                                <h2><span>Value / Volume Toppers</span></h2>
                            </div>
                            <MarketEquity optionInfoMarket={optionInfoMarket} optionTypeComp={optionTypeComp} />
                            <div className='value-table-main'>
                                <div className="valuetopperselect">
                                    <div className='value-loser-toggle'>
                                        <button id="btnGain" value="val" className={(valuebtn === "val") ? "active" : ''} onClick={(event) => { setValueBtn(event.target.value) }}>Value</button>
                                        <button id="btnLoose" value="vol" className={(valuebtn === "vol") ? "active" : ''} onClick={(event) => { setValueBtn(event.target.value) }}>Volume</button>
                                    </div>

                                    <div className='value-inner-select_I'>
                                        
                                        {/* aria-label="nse bse" */}
                                        <select aria-label="nse bse" onChange={(event) => { setGroupValue(event.target.value); setGroupIndex("BSE_SENSEX"); setGroupIndexNSE("NIFTY") }}>
                                            <option value="BSE" selected>BSE</option>
                                            <option value="NSE">NSE</option>
                                        </select>
                                    </div>
                                    <div className='value-inner-selectIndex'>
                                        {(groupValue === "BSE") ?
                                            <select aria-label="bse sensex" onChange={(event) => { setGroupIndex(event.target.value) }}>
                                                {dataGroup && dataGroup.map(({ Group }) => (
                                                    <option value={Group} selected={Group === "BSE_SENSEX"}>{Group}</option>
                                                )
                                                )}
                                            </select> : <select onChange={(event) => { setGroupIndexNSE(event.target.value) }}>
                                                {dataGroup && dataGroup.map(({ Group }) => (
                                                    <option value={Group} selected={Group === "NIFTY"}>{Group}</option>
                                                )
                                                )}
                                            </select>}
                                    </div>
                                </div>

                                {/* <hr className="hr_val_vol"></hr> */}
                                <div className='value-table table-responsive'>
                                    <table className='table'>
                                        <thead>
                                            <tr>
                                                <th className=' padbottom30' rowspan="2">Company Name</th>
                                                <th className='text-center ' >LTP(&#8377;)</th>
                                                <th className='text-right' >Prev Close(&#8377;)</th>
                                                <th className='text-right'>Change</th>
                                                <th className='text-right'>Change(%)</th>
                                                <th className="text-right ">Turnover</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {currentTableData && currentTableData.map(
                                                ({ CompLongName, close_price, PrevClose, perchg, netchg, turnoveravg, CO_CODE }) => (
                                                    <tr>
                                                        <td className="text-left"><h6 onClick={routeChange} data-id={CompLongName + '-' + CO_CODE} tabIndex={0} >{CompLongName}</h6></td>
                                                        <td className="text-right"> {(close_price != null) ? close_price.toFixed(2) : 0}</td>
                                                        <td className="text-right"> {(PrevClose != null) ? PrevClose.toFixed(2) : 0}</td>
                                                        <td className={(netchg > 0) ? "text-right textGreen" : "text-right textRed"}> {(netchg != null) ? netchg.toFixed(2) : 0}</td>
                                                        <td className={(perchg > 0) ? "text-right textGreen" : "text-right textRed"}> {(perchg != null) ? perchg.toFixed(2) : 0}</td>
                                                        <td className="text-right"> {(turnoveravg != null) ? turnoveravg.toFixed(2) : 0}</td>

                                                    </tr>
                                                ))}
                                        </tbody>
                                    </table>

                                    {loadingshow ? <div className="textcentervertex">
                                        <Vortex
                                            visible={true}
                                            height="80"
                                            width="80"
                                            ariaLabel="vortex-loading"
                                            wrapperStyle={{}}
                                            wrapperClass="vortex-wrapper"
                                            colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                        />
                                        <div className="model_popup">Please Wait...</div>
                                    </div> : ""
                                    }


                                </div>
                                {(data != null && data != []) ?
                                    <Pagination
                                        className="pagination-bar_peer"
                                        currentPage={currentPage}
                                        totalCount={(data.length != null) ? data.length : 0}
                                        pageSize={PageSize}
                                        onPageChange={page => setCurrentPage(page)}
                                    /> : <p className="errorPeer"> No Data Found !!! </p>}
                            </div>
                        </section>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default ValueVolumeToppers;   